<script lang="ts">
    import { operationSources } from "../../../config"
    import { _ } from "svelte-i18n"
    import { tooltip } from "../../../helper"

    export let value: any
    export let additionalInfo = ""
    export let externalLink: string = null
</script>

<style lang="less">
    a {
        text-decoration: none;
        color: #c4102d;
    }
</style>

{#if externalLink}
    <a href="{externalLink}" target="_blank" rel="noopener noreferrer">
        <img
            src="{operationSources[value]?.img}"
            alt=""
            width="24"
            use:tooltip="{{
                content:
                    `${$_('general.origin')}: ` +
                    operationSources[value]?.label +
                    (additionalInfo ? '\n' + additionalInfo : ''),
            }}"
        />
        <!-- svg with small arrow to indicate link -->
        <svg width="1em" height="1em" viewBox="0 0 24 24"
            ><path d="M10,17V14H3V10H10V7L15,12L10,17Z" fill="currentColor"></path></svg
        >
    </a>
{:else}
    <img
        src="{operationSources[value]?.img}"
        alt=""
        width="24"
        use:tooltip="{{
            content:
                `${$_('general.origin')}: ` +
                operationSources[value]?.label +
                (additionalInfo ? '\n' + additionalInfo : ''),
        }}"
    />
{/if}
